import { EventEmitter } from "events";
import dispatcher from "../dispatchers/dispatcher";
import Mapper from "../constants/mapping";
import * as BirthdayData from "../constants/birthdayData";
import ExtraFieldStores from "./extrafieldstores";
import { isEmpty } from "../constants/is";
import i18n from "../i18nNext";
import orgLoaderData from "../constants/orgLoaderData";
const currencyMap = {
    INR: "₹",
    USD: "$",
    EUR: "€",
    GBP: "£",
    JPY: "¥"
};

class UserInfoStores extends EventEmitter {
    constructor() {
        super();
        this.initData();
    }
    initData() {
        this.userInfo = {};
        this.userGroupInfo = {};
        this.userHistoryItems = {};
        this.userAdhocItems = {};
        this.userRoleList = {};
        this.orgBal = "";
        this.snackbarStr = "";
        this.snackbarComponentStr = "";
        this.controlledUserInfo = {};
        this.defaultCurrency = "INR";
        this.defaultOrgCurrency = "";
        this.successRoleChageBit = false;
        this.myRolesAndSuperiors = {};
        this.walletList = [];
        this.cardList = [];
        this.cardListTotalCount = 0;
        this.priPermission = [];
        this.priPermissionType = "";
        this.showViewDrawer = false;
        this.showPassbookDrawer = false;
        this.fromDate = "";
        this.toDate = "";
        this.drawerType = "";
        this.object_id = "";
        this.workflow_obj = {};
        this.userNotificationsList = [];
        this.pdfConfig;
        this.TandCStatus;
        this.typeOfUpdate = {};
        this.showActionBar = { isDisplay: false, users: [], selectAllBool: false, pks: [] };
        this.attachmentArr = [];
        this.tabtype = "";
        this.indexImg;
        this.empInviteData = {};
        this.curr = "";
        this.sizeperpage = "";
        this.disablePrevButton = false;
        this.disableNextButton = false;
        this.workflow_expense_splitable = false;
        this.workflow_expense_editable = false;
        this.passedRef = null;
        this.urlType = "";
        this.msgForToaster = { message: "", toastType: 0 };
        this.flexiElement = false;
        this.flexi_benefits = {};
        this.tabValue = false;
        this.ocrValue = false;
        this.usercodeInfo = "";
        this.editlimit = false;
        this.userCreationData = {};

        this.setOrgWorkFlowList = [];
        this.showInterChangeLoader = [];
        this.expenseDrawerViewStatus = true;
        this.setHome = "";
        this.deleteteRpt = false;
        this.fileObj = {};
        this.expenseDrawerViewStatus = true;
        this.omcCardPerm = false;
        this.cancelFile = "";
        this.setClmMngmtObj = {};
        this.other_balance = {};
        this.fromPage = "";
        this.cardDetails = "";
        this.pendingTranxData = {};
        this.mergeTxnData = {};
        this.minKycStatus = true;
        this.languageList = [];
        this.adhocCount = "";
        this.fromPageEditable = false;
        this.fromPageSplitable = false;
        this.formPageRemovable = false;
        this.birthdayImageLists = {
            // image_file: "./assets/images/Dashboard-banner-V2.jpg"
            // image_file: "./assets/images/near_year_happay.png"
            image_file: "./assets/images/covid-19.png"
        };
        this.travelLoader = false;
        this.contentType = "";
        this.txnActions = {};
        this.trf_id == null;
        this.mailForwardId = {};
        this.showEpicCardBtn = false;
        this.pendingItemsReport = {};
        this.pendingItemsTrf = {};
        this.pendingItemsMoneyRequest = {};
        this.pendingItemsCardLoad = {};
        this.defaultApprovers = [];
        this.binType = "";
        this.bulkCopyExpense = [];
        this.forceKycData = false;
        this.orgEstimateTime = 18;
    }
    _setBulkCopyTxnList(data){
        this.bulkCopyExpense = data;
    }
    _getBulkCopyTxnList(){
        return this.bulkCopyExpense;
    }
    openOfficalInfoModal(controlledUserId = "", controlledUserInfo) {
        this.controlledUserId = controlledUserId;
        this.controlledUserInfo = controlledUserInfo;
        this.emit("change", "OPEN_OFFICIAL_INFO_MODAL");
    }

    _getValue(type) {
        return this[type];
    }

    _getMyRoleAndSuperior(data) {
        this.myRolesAndSuperiors = data;
        this.emit("change", "getRolesAndSuperiors");
    }

    _minKycDocumentValidation(document_type, document_id) {
        if (document_type === "pan_card") {
            var pan_number_regex = Mapper["PAN_CARD_REGEX"];
            var regex_bit = pan_number_regex.test(document_id);
            if (!regex_bit) {
                this.showToast("Please enter PAN number in a valid format.");
                return false;
            } else if (document_id.length != 10) {
                this.showToast("PAN number must contain 10 alpha-numeric value");
                return false;
            } 
                return true;
            
        } else if (document_type === "driving_license") {
            var DL_number_regex = Mapper["DRIVING_LICENSE_REGEX"];
            /* eslint-disable no-redeclare */
            var regex_bit = DL_number_regex.test(document_id);
            if (!regex_bit) {
                this.showToast("Please enter Driving Licence number in a valid format.");
                return false;
            } else if (document_id.length <= 14 || document_id.length >= 17) {
                this.showToast("Driving Licence number must contain 15 or 16 alpha-numeric value");
                return false;
            } 
                return true;
            
        } else if (document_type === "passport") {
            var passport_number_regex = Mapper["PASSPORT_REGEX"];
            var regex_bit = passport_number_regex.test(document_id);
            if (!regex_bit) {
                this.showToast("Please enter Passport number in a valid format.");
                return false;
            } else if (document_id.length != 8) {
                this.showToast("Passport number must contain 8 alpha-numeric value");
                return false;
            } 
                return true;
            
        } else if (document_type === "voter_id") {
            var voter_regex = Mapper["VOTER_ID"];
            var regex_bit = voter_regex.test(document_id);
            if (!regex_bit) {
                /* eslint-enable no-redeclare */
                this.showToast("Please enter Voter ID in a valid format.");
                return false;
            } else if (document_id.length != 8) {
                this.showToast("Voter ID must contain 10 alpha-numeric value");
                return false;
            } 
                return true;
            
        } 
            return true;
        
    }
    openCloseColumnManagementPopOver(tempObj) {
        if (tempObj.hasOwnProperty("content_type")) {
            this.setClmMngmtObj = tempObj;
            this.emit("change", tempObj.content_type);
        } else {
            this.setClmMngmtObj = tempObj;
            this.emit("change", "openPopOver");
        }
    }
    _getOpenCloseColumnManagementPopOver() {
        return this.setClmMngmtObj;
    }
    userGetRoleAndSuperior() {
        return this.myRolesAndSuperiors;
    }

    _setEmpInviteData(data) {
        this.empInviteData = data;
        this.emit("change", "get_emp_invite_data");
    }

    _getEmpInviteData() {
        return this.empInviteData;
    }

    _getOrgTimeZone() {
        return this.orgTimeZone;
    }
    _getUserInfo(userInfoList) {
        this.userInfo = userInfoList;
        let { cards, kyc_status, min_kyc, timezone } = userInfoList;
        this.defaultCurrency = userInfoList.default_currency || "INR";
        this.omcCardPerm = userInfoList.is_omc_org || false;
        this.orgTimeZone = timezone;
        this.minKycStatus = true;
        if (userInfoList && cards.length && kyc_status === 3 && isEmpty(min_kyc)) {
            this.minKycStatus = false;
        }
        const { role_types } = userInfoList;
        // if (
        //     role_types &&
        //     role_types.length &&
        //     userInfoList.org_id !== "HPORG2019618147331678353601HP"
        // ) {
        //     const role =
        //         role_types &&
        //         role_types.filter(el => {
        //             if (el.name === "super admin" || el.name === "finance") {
        //                 return el;
        //             }
        //         });
        //     if (role && role.length && userInfoList.default_currency === "INR") {
        //         this.birthdayImageLists = {
        //             image_file: "./assets/images/Epic-Corporate-purcahse-card-new-V2.jpg"
        //         };
        //         this.showEpicCardBtn = true;
        //         this.emit("change", "getBirthdayDetails");
        //     }
        // }

        // Temporary fix for locale_code as by default locale_code should be en-in

        // userInfoList.locale_code =
        //     userInfoList.locale_code === "en-us" ? "en-in" : userInfoList.locale_code;

        userInfoList.locale_code && i18n.changeLanguage(userInfoList.locale_code);
        this.userInfo.company_logo_url_nav =
            userInfoList.company_logo_url || userInfoList.client_logo_url;
        this.userInfo.company_logo_url = this.userInfo.client_logo_url;
        this.emit("change", "userinfo");
    }

    setEmpProfilePic(picUrl) {
        this.userInfo.profile_pic_url = picUrl;
        this.emit("change", "userinfo", "profile-pic-changed");
    }

    _getEpicCardBtnInfo() {
        return this.showEpicCardBtn;
    }
    _showMVPopup() {
        this.emit("change", "SHOW_MV_POPUP");
    }

    _returnMinKycStatus() {
        return this.minKycStatus;
    }

    _getOmcCardPerm() {
        return this.omcCardPerm;
    }

    _getPriPermission(type, perm) {
        this.priPermission = perm;
        this.priPermissionType = type;
        this.emit("change", "priPermission");
    }
    _setEmpWallets(walletList) {
        this.walletList = walletList.filter(el => el.status != 2);
        this.emit("change", "emp_wallet");
    }
    _getEmpWallets() {
        return this.walletList;
    }
    _setEmpCard(cards) {
        this.cardList = cards.result;
        this.cardListTotalCount = cards.count;
        this.emit("change", "GET_EMP_CARD");
    }
    _getEmpCards() {
        return this.cardList || [];
    }
    _getTotalCardListCount() {
        return this.cardListTotalCount || 0;
    }
    updateWalletOnCard(cardId, walletId) {
        this.cardList = this.cardList.map(card => {
            const newCard = { ...card };
            if (newCard.card_kit_id === cardId) {
                newCard.default_wallet = walletId;
            }
            return newCard;
        });
        this.emit("change", "GET_EMP_CARD");
    }
    _getMsgForToast() {
        return this.msgForToaster;
    }

    _setViewDrawerVisibility(data) {
        this.showViewDrawer = data.openDrawer;
        this.drawerType = data.type;
        this.object_id = data.object_id;
        this.workflow_obj = data.workflow_obj;
        this.deleteteRpt = data.deleteteRpt;
        this.fromPage = data.fromPage;
        this.fromPageEditable = data.fromPageEditable;
        this.fromPageSplitable = data.fromPageSplitable;
        this.formPageRemovable = data.formPageRemovable;
        this.contentType = data.contentType;
        this.txnActions = data.txnActions;
        this.trf_id = data.trf_id;
        this.smartAuditFailed = data.smartAuditFailed;
        this.requestorInfo = data.requestorInfo;
        this.daTxn = data.daTxn;

        if (data.isConType) {
            this.gaData = data.data;
            this.ct_id = data.ct_id;
        } else {
            this.workflow_expense_splitable = data.workflow_expense_splitable;
            this.workflow_expense_editable = data.workflow_expense_editable;
            this.passedRef = data.passedRefs;
        }

        this.emit("change", "viewDrawerVisibility");
    }

    getUserCodeInfo(UserInfotype) {
        for (let user in UserInfotype.extra_fields) {
            if (UserInfotype.extra_fields[user].is_identifier) {
                return (this.usercodeInfo = {
                    fieldName: user,
                    fieldValue: UserInfotype.extra_fields[user].field_value
                });
            }
        }
    }

    setExpenseDrawerViewStatus = data => {
        this.expenseDrawerViewStatus = data.value;
        this.emit("change", "expenseDrawerViewStatus");
    };

    getDrawerVisiblityStatus = () => {
        return this.expenseDrawerViewStatus;
    };

    _showViewDrawer() {
        let tempObj = {};
        tempObj["showViewDrawer"] = this.showViewDrawer;
        tempObj["drawerType"] = this.drawerType;
        tempObj["object_id"] = this.object_id;
        tempObj["workflow_obj"] = this.workflow_obj;
        tempObj["deleteteRpt"] = this.deleteteRpt;
        tempObj["fromPage"] = this.fromPage;
        tempObj["fromPageEditable"] = this.fromPageEditable;
        tempObj["fromPageSplitable"] = this.fromPageSplitable;
        tempObj["formPageRemovable"] = this.formPageRemovable;
        tempObj["contentType"] = this.contentType;
        tempObj["txnActions"] = this.txnActions;
        tempObj["trf_id"] = this.trf_id;
        tempObj["smartAuditFailed"] = this.smartAuditFailed;
        tempObj["requestorInfo"] = this.requestorInfo;
        tempObj["daTxn"] = this.daTxn;
        if (this.ct_id) {
            tempObj.ct_id = this.ct_id;
            tempObj.gaData = this.gaData;
        } else {
            tempObj["workflow_expense_splitable"] = this.workflow_expense_splitable;
            tempObj["workflow_expense_editable"] = this.workflow_expense_editable;
            tempObj["passedRef"] = this.passedRef;
        }
        return tempObj;
    }
    _setPassbookDrawerVisibility(data) {
        this.showPassbookDrawer = data.openDrawer;
        this.fromDate = data.from_date;
        this.toDate = data.to_date;
        this.emit("change", "passbookDrawerVisibility");
    }
    _showPassbookDrawer() {
        let tempObj = {};
        tempObj["showPassbookDrawer"] = this.showPassbookDrawer;
        tempObj["fromDate"] = this.fromDate;
        tempObj["toDate"] = this.toDate;
        return tempObj;
    }
    getDefaultCurrency(noCurrencySymbol = false) {
        // If anywhere someone wants the alpha code but not the symbol then they can pass as true
        if (noCurrencySymbol) {
            return this.defaultCurrency;
        } 
            return this.getCurrencySymbol(this.defaultCurrency);
        
    }
    getCurrencySymbol(currency) {
        return currencyMap[currency] || currency;
    }
    _getUserPermission(key, type) {
        //type - if true then it will do OR condition
        let list = [];
        if (this.priPermissionType == "GET_PRIV_PERM")
            list =
                this.priPermission && this.priPermission.permission_list
                    ? this.priPermission.permission_list
                    : [];
        else
            list =
                this.userInfo && this.userInfo.permission_list ? this.userInfo.permission_list : [];
        if (typeof key === "string") {
            return list.indexOf(key) !== -1 ? true : false;
        } 
            let perm = type ? false : true;
            for (let i in key) {
                if (!type && list.indexOf(key[i]) === -1) return false;
                if (type && list.indexOf(key[i]) !== -1) perm = true;
            }
            return perm;
        
    }
    getOrgDefaultCurrency() {
        return this.defaultOrgCurrency;
    }
    _getEmployeeGroupInfo(employeeGroupInfo, id) {
        this.userRoleList.groups.filter(el => {
            if (el.group_id == id) {
                el.info = employeeGroupInfo;
            }
            return el;
        });
        this.emit("change", "userinfo");
    }
    _getUserHistoryItems(history) {
        this.userHistoryItems = history;
        this.emit("change", "historyitems");
    }
    _getUserAdhocItems(adhoc, cnt) {
        const tempval = adhoc ? adhoc.adhoc_items : [];
        let count = 0;
        tempval.forEach(el => {
            count += el.count;
        });
        this.adhocCount = count;
        this.userAdhocItems = tempval;
        this.emit("change", "adhocitems");
    }
    _getUserRolesGroups(userList) {
        this.userRoleList = userList;
        this.emit("change", "userrolegroups");
    }
    isUserInfoAPIDone() {
        return Boolean(Object.keys(this.userInfo).length);
    }
    isPermInfoAPIDone() {
        return Boolean(Object.keys(this.priPermission).length);
    }
    getAllUserInfoStores() {
        return this.userInfo;
    }
    getUserGroupInfoStores() {
        return this.userGroupInfo;
    }
    getAllUserHistoryItems() {
        return this.userHistoryItems;
    }
    getAllUserAdhocItems() {
        return this.userAdhocItems;
    }
    getAllUserAdhocCount() {
        return this.adhocCount;
    }
    getAllUserRoleGroupsStores() {
        return this.userRoleList;
    }
    /*_getUserWallets(){
		return this.userInfo.wallets||[];
	}*/
    getSnackbarStr() {
        return this.snackbarStr;
    }
    getLoader() {
        return this.loader;
    }
    getTravelLoader() {
        return this.travelLoader;
    }
    getOrgBalance() {
        return this.orgBal;
    }
    _getWalletName(wallet_id) {
        if (this.walletList) {
            let wallets = this.walletList;
            for (let i in wallets) {
                if (wallets[i].wallet_id == wallet_id) return wallets[i].wallet_name;
            }
        }
        return "";
    }
    _getFileData() {
        return this.fileObj;
    }
    _sendFile(file, type, userId, viewType, url) {
        this.fileObj[type] = file;
        this.fileObj["id"] = userId;
        this.fileObj[viewType] = viewType;
        this.fileObj["uploadURL"] = url;
        this.emit("change", "fileObj");
    }

    _getCancelFile() {
        return this.cancelFile;
    }
    _cancelUpload(file) {
        this.cancelFile = file;
        this.emit("change", "cancelUpload");
    }
    _getTotalWalletBalance(type) {
        if (type === "Employee") {
            if (this.walletList) {
                let sum = 0;
                this.walletList.filter(el => {
                    sum += parseFloat(el.trans_limit);
                });
                return sum.toFixed(2);
            }
            return "";
        } 
            return this.orgBal;
        
    }
    showSnackbar(message, toastType = 1) {
        this.snackbarStr = message;
        this.msgForToaster = { message, toastType };
        this.emit("change", "snackbar");
    }
    showToast(message, toastType = 1) {
        this.msgForToaster = { message, toastType };
        this.emit("change", "toast");
    }
    showLoader(loader) {
        this.loader = loader;
        this.emit("change", "loader");
    }
    showTravelLoader(loader) {
        this.travelLoader = loader;
        this.emit("change", "travelLoader");
    }
    _showBalance(val, currency, other_balances) {
        this.orgBal = val;
        this.defaultOrgCurrency = currency;
        this.other_balance = other_balances;
        this.emit("change", "orgBalance");
    }
    getOmcBalance() {
        return this.other_balance;
    }
    showMessageComponent(message) {
        this.snackbarComponentStr = message;
        this.emit("change", "componentmessage");
    }

    showMessage() {
        return this.snackbarComponentStr;
    }
    _updateCardStatus(status, msg, id) {
        this.cardList = this.cardList.map(el => {
            if (el.card_kit_id == id) {
                el.is_active = status.cur_status == "Active" ? true : false;
            }
            return el;
        });
        this.emit("change", "GET_EMP_CARD");
    }

    _updateCardStatusEmp(status, msg, id) {
        this.controlledUserInfo.cards = this.controlledUserInfo.cards.map(el => {
            if (el.card_kit_id === id) {
                el.is_active = status.cur_status === "Active";
            }
            return el;
        });
        this.emit("change", "CONTROLLED_USER_INFO");
    }

    _updateControlledUserInfo(newValue) {
        this.controlledUserInfo = newValue;
        this.emit("change", "CONTROLLED_USER_INFO");
    }

    _getControlledUserInfo() {
        return this.controlledUserInfo;
    }

    updateControlledUserCardDefaultWallet(cardId, walletId) {
        this.controlledUserInfo.cards = this.controlledUserInfo.cards.map(card => {
            const newCard = { ...card };
            if (newCard.card_kit_id === cardId) {
                newCard.default_wallet = walletId;
            }
            return newCard;
        });
        this.emit("change", "CONTROLLED_USER_INFO");
    }

    _resetControlledUserInfo() {
        this.controlledUserInfo = {};
    }

    _getControlledUserRoles(employeeGroupInfo, id) {
        this.controlledUserInfo.groups.filter(el => {
            if (el.group_id == id) {
                el.info = employeeGroupInfo;
            }
            return el;
        });
        this.emit("change", "CONTROLLED_USER_INFO");
    }

    _walletInfo(wallet_id) {
        let wallets = this.walletList || [];
        let info = {};
        for (let i = 0; i < wallets.length; i++) {
            if (wallets[i].wallet_id == wallet_id) {
                info = {
                    walletName: wallets[i].wallet_name,
                    walletBalance: wallets[i].trans_limit
                };
            }
        }
        return info;
    }

    _orgPdfConfig() {
        return this.pdfConfig;
    }

    _getPDFConfigurationOrg(data) {
        this.pdfConfig = data;
        this.emit("change", "getPDFConfig");
    }

    _getImprestWalletId() {
        let wallets = this.walletList || [];
        let wallet_id = "";
        for (let i = 0; i < wallets.length; i++) {
            if (wallets[i].wallet_type == "Imprest" && wallets[i].status != 2) {
                wallet_id = wallets[i].wallet_id;
                break;
            }
        }
        if (!wallet_id && wallets.length) wallet_id = wallets[0].wallet_id;
        return wallet_id || "";
    }

    _getDefaultWalletId() {
        let wallets = this.walletList || [];
        let wallet_id = "";
        for (let i = 0; i < wallets.length; i++) {
            if (wallets[i].is_default == "True") {
                wallet_id = wallets[i].wallet_id;
                break;
            }
        }
        return wallet_id || "";
    }

    _setApproverRoleSuccess(str) {
        if (str == "success") {
            this.successRoleChageBit = true;
            this.emit("change", "editSuccess");
        }
    }

    _getApproveSuccessBit() {
        return this.successRoleChageBit;
    }

    _setDefaultWallet(id) {
        this.walletList = this.walletList.map(el => {
            if (el.wallet_id === id) el.is_default = "True";
            else el.is_default = "False";
            return el;
        });
        this.emit("change", "emp_wallet");
    }

    _setUserInfoToDelete(info) {
        this.userinfoToDelete = info;
        this.emit("change", "userinfoToDelete");
    }

    _getUserInfoToDelete() {
        return this.userinfoToDelete;
    }

    _deletUserSuccess() {
        this.emit("change", "delete_user_success");
    }

    _setUserNotifications(list) {
        this.userNotificationsList = list;
        this.emit("change", "userNotificationsList");
    }

    _getUserNotifications() {
        return this.userNotificationsList;
    }

    _setToggledNotification() {
        this.emit("change", "userNotificationToggled");
    }
    _typeOfUpdate(type, data) {
        this.typeOfUpdate[type] = data;
        this.emit("change", type);
    }
    _getTypeOfData(key) {
        return this.typeOfUpdate[key];
    }
    _openLightBox(attachmentArr, indexImg) {
        this.attachmentArr = attachmentArr;
        this.indexImg = indexImg;
        this.emit("change", "openLightBox");
    }
    _getLightBoxData() {
        let data = {};
        data.attachmentArr = this.attachmentArr;
        data.indexImg = this.indexImg;
        return data;
    }
    _checkType(type) {
        this.tabtype = type;
        this.emit("change", "tabtype");
    }
    _getcheckTabType() {
        return this.tabtype;
    }

    _makeEditableProfile(boolean) {
        this.editlimit = boolean;
        this.emit("change", "userinfoEditable");
    }
    _getBooleanEditLimitValue() {
        return this.editlimit;
    }
    _setStatusActionBarForUsers(isDisplay, users, selectAllBool, pks) {
        this.showActionBar = { isDisplay, users, selectAllBool, pks };
        this.emit("change", "showActionBar");
    }

    _getStatusActionBarForUsers() {
        return this.showActionBar;
    }
    _handleCurrentPage(curr, sizeperpage, disablePrevButton, disableNextButton) {
        this.curr = curr;
        this.sizeperpage = sizeperpage;
        this.disablePrevButton = disablePrevButton;
        this.disableNextButton = disableNextButton;
        this.emit("change", "updateCurrent");
    }
    _getCurrentPage() {
        let data = {};
        data.curr = this.curr;
        data.sizeperpage = this.sizeperpage;
        data.disablePrevButton = this.disablePrevButton;
        data.disableNextButton = this.disableNextButton;
        return data;
    }
    _sendType(urlType) {
        this.urlType = urlType;
        this.emit("change", "urlType");
    }
    _getType() {
        return this.urlType;
    }
    _setflexiType(flexi_benefits) {
        this.flexi_benefits = flexi_benefits;
        this.emit("change", "flexi_benefits");
    }
    _getFlexiType() {
        return this.flexi_benefits;
    }

    _flexiElement(flexiElement) {
        this.flexiElement = flexiElement;
        this.emit("change", "flexiElement");
    }
    _getFlexiElement() {
        return this.flexiElement;
    }
    _showtabValue(tabValue) {
        this.tabValue = tabValue;
        this.emit("change", "tabValue");
    }
    _getshowtabValue() {
        return this.tabValue;
    }
    _getContentTypeForBulk(data) {
        let temp = "";
        if (data == "walletload") temp = "load_wallet";
        else if (data == "walletwithdraw") temp = "withdraw_wallet";
        else if (data == "walletlimits") temp = "wallet_limit_setting";
        return temp;
    }
    _getLoadData(type) {
        let temp = "";
        if (type == "walletload") temp = i18n.t("flexi.walletLoad");
        else if (type == "walletwithdraw") temp = i18n.t("flexi.walletWithdraw");
        else if (type == "walletlimits") temp = i18n.t("flexi.walletlimits");
        return temp;
    }
    // _getLoadData(type) {
    //     let temp = "";
    //     if (type == "walletload") temp = i18n.t("flexi.walletLoad");
    //     else if (type == "walletwithdraw") temp = i18n.t("flexi.walletWithdraw");
    //     return temp;
    // }
    // _getLoadData(type) {
    //     let temp = "";
    //     if (type == "walletload") temp = "wallet load";
    //     else if (type == "walletwithdraw") temp = "wallet withdraw";
    //     return temp;
    // }

    // _saveOCRConfig(data) {
    //     this.ocrValue = data;
    //     this.emit("change", "ocrValue");
    // }

    _saveOCRConfig(data) {
        this.ocrValue = data;
        this.emit("change", "ocrValue");
    }

    _getOCRConfig() {
        return this.ocrValue;
    }

    _sendUpdateSingleUserCreation(data) {
        this.userCreationData = data;
    }

    _getUserCreationData() {
        return this.userCreationData;
    }
    _setHomePage(type) {
        this.setHome = type;
        this.emit("change", type);
    }
    _getHomePage() {
        return this.setHome;
    }
    _setOrgWorkFlowList(data, type) {
        this.setOrgWorkFlowList = data;
        this.emit("change", type);
    }
    _getOrgWorkFlowList() {
        return this.setOrgWorkFlowList;
    }
    _setOrgWorkFlowLogin(data, type) {
        this.showInterChangeLoader = data;
        this.emit("change", type);
    }
    _getOrgWorkFlowLogin() {
        return this.showInterChangeLoader;
    }
    _setCardDetails(data) {
        this.cardDetails = data.card_id || "";
    }
    _getCardDetails() {
        return this.cardDetails;
    }

    _setPendingTransaction(data, type, status, storeEmitType) {
        this.pendingTranxData = status == "0" ? data : {};
        this.emit(storeEmitType, type);
    }
    _getPendingTransaction() {
        return this.pendingTranxData;
    }
    _setMeargeTxnLatest(data, type) {
        this.mergeTxnData = data;
        this.emit("change", type);
    }
    _getMeargeTxnLatest() {
        return this.mergeTxnData;
    }

    _setLanguages(data, type) {
        this.languageList = data;
        this.emit("change", type);
    }

    _getLanguages() {
        return this.languageList;
    }
    _setBirthdayImageLists(response) {
        if (Object.keys(response).length && "image_file" in response) {
            let birthdayImageListsClone = {...this.birthdayImageLists};
            if (BirthdayData._isShowBirthdayMsg(response)) {
                birthdayImageListsClone.image_file = response.image_file;
            }
            this.birthdayImageLists = birthdayImageListsClone;
            this.emit("change", "getBirthdayDetails");
        }
    }
    _getBirthdayImageLists() {
        return this.birthdayImageLists;
    }

    freshBotSuccess() {
        this.emit("change", "freshBotSuccess");
    }
    _setMailForwardId(data) {
        this.mailForwardId = data;
        this.emit("change", "mail_forward_id");
    }
    _getMailForwardId() {
        return this.mailForwardId;
    }

    setDaConfig(action) {
        this.daConfig = action.response;
        this.emit("change", "daConfig");
    }

    getDaConfig() {
        return this.daConfig;
    }

    _setDefaultApprovers(data) {
        this.defaultApprovers = data;
        this.emit("change", "defaultApproversList");
    }

    _getDefaultApprovers() {
        return this.defaultApprovers;
    }

    _setMeargeDataForPost(data, type) {
        this.setMerageDataPost = data;
        this.emit("change", type);
    }
    _getMeargeDataForPost() {
        return this.setMerageDataPost;
    }
    _setPendingItemsReport(pendingReport) {
        this.pendingItemsReport = pendingReport;
        this.emit("change", "pendingReport");
    }
    _getPendingItemsReport() {
        return this.pendingItemsReport;
    }
    _setPendingItemsTrf(pendingTrf) {
        this.pendingItemsTrf = pendingTrf;
        this.emit("change", "pendingTrf");
    }
    _getPendingItemsTrf() {
        return this.pendingItemsTrf;
    }
    _setPendingItemsMoneyRequest(pendingMoneyRequest) {
        this.pendingItemsMoneyRequest = pendingMoneyRequest;
        this.emit("change", "pendingMoneyRequest");
    }
    _getPendingItemsMoneyRequest() {
        return this.pendingItemsMoneyRequest;
    }
    _setPendingItemsCardLoad(pendingCardLoad) {
        this.pendingItemsCardLoad = pendingCardLoad;
        this.emit("change", "pendingCardLoad");
    }
    _getPendingItemsCardLoad() {
        return this.pendingItemsCardLoad;
    }

    _setBinType(value) {
        this.binType = value;
    }

    getBinType() {
        return this.binType;
    }

    _setForceKycUserData(value) {
        this.forceKycData = value?.full_kyc_banner?.force_kyc || false;
        this.emit("change", "FORCE_USER_KYC");
    }

    getForceKycUserData() {
        return this.forceKycData;
    }

    setUserAdditionalInfo(res) {
        this.orgEstimateTime = res?.org_estimate_time?.create_txn || orgLoaderData?.[localStorage.getItem("happay.org_id")] || 6;
        this.emit("change", "additionalInfo");
    }

    getUserAdditionalInfo() {
        return this.orgEstimateTime;
    }

    _isQCChannel() {
        const isQC = this.userInfo?.channel?.toLowerCase()?.includes("hs-qc") || false;
        return isQC;
    }
    _handleActions(action) {
        switch (action.type) {
            case "GET_USER_INFO": {
                this._getUserInfo(action.response);
                break;
            }
            case "GET_EMP_PROFILE_PIC": {
                this.setEmpProfilePic(action.picUrl);
                break;
            }
            case "GET_EMP_WALLET": {
                this._setEmpWallets(action.response);
                break;
            }
            case "GET_EMP_CARD": {
                this._setEmpCard(action.response);
                break;
            }
            case "UPDATE_DEFAULT_WALLET_ON_SPECIFIC_CARD_TYPE":
            case "UPDATE_DEFAULT_WALLET_ON_CARD":
                this.updateWalletOnCard(action.cardkitId, action.walletId);
                break;
            case "UPDATE_DEFAULT_WALLET_ON_CONTROLLED_USER": {
                this.updateControlledUserCardDefaultWallet(action.cardkitId, action.walletId);
                break;
            }
            case "EMPLOYEE_GROUPINFO": {
                this._getEmployeeGroupInfo(action.response, action.group_id);
                break;
            }
            case "HISTORY_ITEM": {
                this._getUserHistoryItems(action.response);
                break;
            }
            case "ADHOC_ITEM": {
                this._getUserAdhocItems(action.response, action.adhocCnt);
                break;
            }
            case "ROLES_GROUPS": {
                this._getUserRolesGroups(action.response);
                break;
            }
            case "SNACKBAR": {
                this.showToast(action.str, action.toastType);
                break;
            }
            case "TOAST": {
                this.showToast(action.str, action.toastType);
                break;
            }
            case "LOADER": {
                this.showLoader(action.loader);
                break;
            }
            case "BALANCE": {
                this._showBalance(
                    action.response.balance,
                    action.response.default_currency,
                    action.response.other_balances
                );
                break;
            }
            case "NO_PERM_BALANCE": {
                this.orgBal = "";
                this.emit("change", "orgBalance");
                break;
            }
            case "SNACKBAR_COMPONENT": {
                this.showMessageComponent(action.errormessage);
                break;
            }
            case "UPDATE_CARD_STATUS_PARTICULAR": {
                this._updateCardStatus(action.response, action.str, action.cardId);
                break;
            }
            case "UPDATE_CARD_STATUS_PARTICULAR_EMP": {
                this._updateCardStatusEmp(action.response, action.str, action.cardId);
                break;
            }
            case "CHANGEVIEW": {
                this.emit("change", "changeview");
                break;
            }
            case "EXIT_DELEGATION": {
                this.emit("change", "exitdelegation");
                break;
            }
            case "INFOUPDATED": {
                ExtraFieldStores._flushExtrafieldMap("user");
                this.emit("change", "infosaved");
                break;
            }
            case "CONTROLLED_USER_INFO": {
                this._updateControlledUserInfo(action.response);
                break;
            }
            case "CONTROLLED_USER_GROUP_INFO": {
                this._getControlledUserRoles(action.response, action.group_id);
                break;
            }
            case "DEFAULT_WALLET": {
                this._setDefaultWallet(action.response);
                break;
            }
            case "APPROVER_ROLE_CHANGE": {
                this._setApproverRoleSuccess(action.response);
                break;
            }
            case "GET_USER_ROLES_SUPERIORS": {
                this._getMyRoleAndSuperior(action.response);
                break;
            }
            case "ONBOARD_ERROR": {
                this.emit("change", "oboarderror");
                break;
            }
            case "REMOVE_ROLE_WARNING": {
                this.emit("change", "role_remove_warning");
                break;
            }
            case "REMOVE_APPROVER_WARNING": {
                this.emit("change", "approver_remove_warning");
                break;
            }
            case "FORCE_ROLE_REMOVAL": {
                this.emit("change", "force_role_removal");
                break;
            }
            case "FORCE_APPROVER_REMOVAL": {
                this.emit("change", "force_approver_removal");
                break;
            }
            case "MOBILE_NUMBER_CHANGE_OTP": {
                this.emit("change", "change_mobile_otp");
                break;
            }
            case "RESEND_EMP_INVITE": {
                this.emit("change", "resend_emp_invite");
                break;
            }
            case "GET_PRIV_PERM": {
                this._getPriPermission(action.type, action.response);
                break;
            }
            case "TO_DELETE_USER_INFO": {
                this._setUserInfoToDelete(action.response);
                break;
            }
            case "DELETE_USER_SUCCESS": {
                this._deletUserSuccess(action.response);
                break;
            }
            case "USER_NOTIFICATIONS": {
                this._setUserNotifications(action.response);
                break;
            }
            case "TOGGLE_USER_NOTIFICATION": {
                this._setToggledNotification();
                break;
            }
            case "AGREE_TERMS_AND_CONDITIONS": {
                this.emit("change", "agree_consent");
                break;
            }
            case "UPDATE_USEREF_BULK": {
                this.emit("change", "UPDATE_USEREF_BULK");
                break;
            }
            case "PDF_CONFIG_GET": {
                this._getPDFConfigurationOrg(action.response);
                // this.emit('change', 'getPDFConfig');
                break;
            }
            case "GET_INVITE_DETAILS": {
                this._setEmpInviteData(action.response);
                break;
            }
            case "DOWNLOAD_BULK_USER":
            case "UPLOAD_XL":
            case "TYPE_OF_UPDATE": {
                this._typeOfUpdate(action.type, action.response);
                break;
            }
            case "CLEAR_ALL": {
                this.initData();
                break;
            }
            case "NO_PERM_VIEW_BALANCE": {
                this.emit("change", "denyPermission");
                break;
            }
            case "KYC_UPDATED_SUCCESSFULLY": {
                this.fileObj = {};
                this.emit("change", "KYC_UPDATED_SUCCESSFULLY");
                break;
            }
            case "FLEXI_DATA": {
                this._setflexiType(action.value);
                break;
            }
            case "OCR_CONFIG": {
                this._saveOCRConfig(action.response);
                break;
            }
            case "ORG_ACESS_LIST": {
                this._setOrgWorkFlowList(action.response, action.type);
                break;
            }
            case "ORG_INETERCHANGE_LOGIN": {
                this._setOrgWorkFlowLogin(action.response, action.type);
                break;
            }
            case "MIGRATE_ORG_USER": {
                this.emit("change", "migrateOrgUser");
                break;
            }
            case "MIN_KYC": {
                this.emit("change", action.type);
                break;
            }
            case "CARD_DETAILS": {
                this._setCardDetails(action.response);
                break;
            }
            case "CONSISTANT_TXN": {
                this._setPendingTransaction(
                    action.response,
                    action.type,
                    action.status,
                    action.storeEmitType
                );
                break;
            }
            case "MERGE_TXN_LATEST": {
                this._setMeargeTxnLatest(action.response, action.type);
            }
            case "GET_LANGUAGES": {
                this._setLanguages(action.response, action.type);
            }
            case "REVOKED_ACCESS": {
                this.emit("change", "revokedData");
                break;
            }
            case "DA_CONFIG": {
                this.setDaConfig(action);
                break;
            }
            case "GET_LANDING_PAGE_IMAGE": {
                this._setBirthdayImageLists(action.response);
                break;
            }
            case "MAIL_FORWARD_ID": {
                this._setMailForwardId(action.response);
                break;
            }
            case "EPIC_INVOICE_MAIL": {
                this.emit("change", "EPIC_INVOICE_MAIL_POST");
                break;
            }
            case "GET_CONFIG_APPROVERS": {
                this._setDefaultApprovers(action.response);
                break;
            }
            case "CONFIG_DEFAULT_APPROVERS": {
                this.emit("change", "configDefaultApprovers");
                break;
            }
            case "MEARGE_EXPENSES_POST": {
                this._setMeargeDataForPost(action.response, action.type);
                break;
            }
            case "PENDING_ITEM_REPORT": {
                this._setPendingItemsReport(action.response);
                break;
            }
            case "PENDING_ITEM_TRF": {
                this._setPendingItemsTrf(action.response);
                break;
            }
            case "PENDING_ITEM_MONEY_REQUEST": {
                this._setPendingItemsMoneyRequest(action.response);
                break;
            }
            case "PENDING_ITEM_CARD_LOAD": {
                this._setPendingItemsCardLoad(action.response);
                break;
            }
            case "GET_BIN_TYPE": {
                this._setBinType(action.response);
                break;
            }
            case "FORCE_USER_KYC": {
                this._setForceKycUserData(action.response);
                break;
            }
            case "ADDIIONAL_TIME_INFO": {
                this.setUserAdditionalInfo(action.response);
                break;
            }
        }
    }
}
const userInfoStores = new UserInfoStores();
if (process.env.NODE_ENV !== "production") window.userInfoStores = userInfoStores;
dispatcher.register(userInfoStores._handleActions.bind(userInfoStores));

export default userInfoStores;
